<script setup lang="ts">
import Picture, { type ImageToolsPictureOption, type PictureProp } from '@kwai-explore/picture.vue';
import { useAbtest } from '@pex/ug-ssr-server/hooks/use-abtest';

const props = defineProps<PictureProp>();
const useAbTest = (useAbtest('ug_toufang_pag_pic1') ?? '0') === '1';
const src = props.src as ImageToolsPictureOption;
const finalSrc = useAbTest || !src.fallback ? src : { fallback: src.fallback };
</script>
<template>
    <div>
        <!-- @vue-ignore -->
        <Picture v-bind="{ ...$attrs }" :src="finalSrc" />
    </div>
</template>
